import * as types from '../actions/actionTypes';
import initialState from './initialState';


        
        
export default function contablecuentaReducer(state= initialState.contablecuenta, action){
    let newState;
	switch(action.type){
         case types.LOAD_CONTABLECUENTA_LIST_SUCCESS:		
            action.contablecuenta.filtroActivo=state.filtroActivo;
            action.contablecuenta.filtroActual=state.filtroActual;
            action.contablecuenta.showActivos=state.showActivos;
			 action.contablecuenta.paginaActual=action.contablecuenta.pageable.pageNumber;
			 action.contablecuenta.registrosPorPagina=action.contablecuenta.size;
            
            return action.contablecuenta;

        case types.BORRAR_CONTABLECUENTA_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(contablecuenta => contablecuenta.id !== action.contablecuenta.id)];          
			return newState;    
            
        case types.ACTIVAR_CONTABLECUENTA_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(contablecuenta => contablecuenta.id !== action.contablecuenta.id)];          
			 return newState;
            
        case types.SET_FILTRO_CONTABLECUENTA:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
           newState.showActivos=action.filtro.showActivos;
            
            
			return newState;
		break;
            
		default:
			return state;
	}
}